import { useMemo } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { usePageMeta, JsonLd } from "@/hooks/useSeo";
import { faqs, testimonials } from "@/mocks/news";

export default function AboutPage() {
  usePageMeta({
    title: "关于98爆料 - 品牌介绍 网站定位 吃瓜口碑 联系方式",
    description:
      "了解98爆料的品牌介绍、网站定位、发展理念与内容原则。98爆料专注娱乐八卦、明星动态、综艺内幕、剧组消息与艺人行程，理性吃瓜，实事求是。",
  });

  const jsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "AboutPage",
          name: "关于98爆料",
          url: "https://bzkrsm.top/about",
          isPartOf: { "@type": "WebSite", name: "98爆料", url: "https://bzkrsm.top/" },
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://bzkrsm.top/" },
              { "@type": "ListItem", position: 2, name: "关于我们" },
            ],
          },
        },
        {
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        },
      ],
    }),
    [],
  );

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Header />

      <main>
        {/* 页头 */}
        <section className="relative overflow-hidden bg-secondary-500">
          <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
            <div className="max-w-2xl">
              <span className="text-xs font-bold tracking-[0.2em] text-secondary-950/70">
                ABOUT 98BAOLIAO
              </span>
              <h1 className="mt-2 font-heading text-3xl font-black text-secondary-50 md:text-5xl">
                关于 98爆料
              </h1>
              <p className="mt-4 text-sm leading-relaxed text-secondary-100 md:text-base">
                让每一个热爱娱乐圈的人，都能在一个地方看懂台前幕后。这里是98爆料，你的日常吃瓜根据地。
              </p>
            </div>
          </div>
        </section>

        {/* 品牌介绍 + 定位 */}
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div>
              <span className="text-xs font-bold tracking-[0.2em] text-primary-600">WHO WE ARE</span>
              <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                我们是谁
              </h2>
              <p className="mt-4 text-sm leading-8 text-foreground-700">
                98爆料诞生于一群热爱影视与综艺的「吃瓜人」手中。我们发现，娱乐信息虽多，却常常碎片化、真假难辨。
                于是我们决定做这样一件事：把明星动态、综艺内幕、剧组消息、艺人行程聚到一处，用清晰、克制、有依据的表达，
                帮大家更高效、更放心地「吃瓜」。
              </p>
              <p className="mt-3 text-sm leading-8 text-foreground-700">
                从第一条瓜报到今天，我们始终坚持一条朴素的原则——不传谣、不造谣，把事实与猜测讲明白。我们相信，
                真正长久的关注，来自每一次「说得准」的积累，而非一时的流量喧嚣。
              </p>
            </div>
            <div>
              <span className="text-xs font-bold tracking-[0.2em] text-accent-600">OUR POSITION</span>
              <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                网站定位
              </h2>
              <p className="mt-4 text-sm leading-8 text-foreground-700">
                98爆料定位为「泛娱乐资讯聚合平台」，面向对娱乐圈台前幕后感兴趣的普通观众、追星群体与资讯爱好者。
                我们以栏目化的方式组织内容：明星动态看实时，综艺内幕看现场，剧组消息看进度，艺人行程看排期，
                让不同关注点的人都能迅速找到自己想看的瓜。
              </p>
              <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
                {[
                  { n: "4+", t: "核心栏目" },
                  { n: "24h", t: "全天跟进" },
                  { n: "100%", t: "信源核实" },
                  { n: "10w+", t: "每日读者" },
                ].map((s) => (
                  <div key={s.t} className="rounded-2xl bg-secondary-100 p-4 text-center">
                    <div className="font-heading text-2xl font-black text-secondary-800">{s.n}</div>
                    <div className="mt-1 text-xs text-foreground-500">{s.t}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 理念 */}
        <section className="bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
            <div className="text-center">
              <span className="text-xs font-bold tracking-[0.2em] text-primary-600">VALUES</span>
              <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                我们坚持的三条理念
              </h2>
            </div>
            <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
              {[
                {
                  icon: "ri-check-double-line",
                  t: "求真",
                  d: "凡发布的信息均经多渠道交叉核实，网传、推测内容会明确标注，把「事实」与「解读」严格区分。",
                },
                {
                  icon: "ri-speed-line",
                  t: "及时",
                  d: "艺人行程、开机路透等一手动态全时段跟进，重要瓜料第一时间送达，让读者掌握先机。",
                },
                {
                  icon: "ri-heart-3-line",
                  t: "有度",
                  d: "理性吃瓜、尊重艺人隐私与合法权益。我们记录娱乐，但从不以伤害换取流量。",
                },
              ].map((v) => (
                <div
                  key={v.t}
                  className="rounded-2xl border border-background-200 bg-background-50 p-6 text-center"
                >
                  <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-500 text-2xl text-background-50">
                    <i className={v.icon}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-black text-foreground-950">{v.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 口碑 */}
        <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <div className="text-center">
            <span className="text-xs font-bold tracking-[0.2em] text-accent-600">REPUTATION</span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              读者口碑
            </h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-100 p-6">
                <blockquote className="text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-black text-accent-700">
                    {t.name.slice(1, 3)}
                  </span>
                  <div>
                    <div className="text-sm font-bold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* FAQ + 联系 */}
        <section className="bg-secondary-100/60">
          <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <span className="text-xs font-bold tracking-[0.2em] text-primary-600">FAQ</span>
              <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                常见问题
              </h2>
              <div className="mt-6 space-y-3">
                {faqs.map((f, i) => (
                  <details
                    key={i}
                    className="group rounded-2xl border border-background-200 bg-background-50 p-5"
                  >
                    <summary className="flex cursor-pointer list-none items-start justify-between gap-3">
                      <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                        <span className="mr-2 text-primary-500">Q{i + 1}.</span>
                        {f.q}
                      </h3>
                      <i className="ri-add-line mt-0.5 shrink-0 text-lg text-foreground-400 transition-transform group-open:rotate-45"></i>
                    </summary>
                    <p className="mt-3 pl-8 text-sm leading-7 text-foreground-600">{f.a}</p>
                  </details>
                ))}
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl border border-background-200 bg-background-100 p-6 lg:sticky lg:top-28">
                <span className="text-xs font-bold tracking-[0.2em] text-accent-600">CONTACT</span>
                <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950">
                  联系我们
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  投稿爆料、商务合作、转载授权或内容反馈，欢迎通过以下方式联系98爆料编辑部，我们会在24小时内回复。
                </p>
                <div className="mt-6 space-y-4">
                  {[
                    { icon: "ri-mail-line", label: "投稿邮箱", value: "tougao@98baoliao.com" },
                    { icon: "ri-customer-service-2-line", label: "合作洽谈", value: "business@98baoliao.com" },
                    { icon: "ri-community-line", label: "官方微博", value: "@98爆料" },
                    { icon: "ri-map-pin-line", label: "编辑部", value: "线上编辑部 · 全网在线办公" },
                  ].map((c) => (
                    <div key={c.label} className="flex items-center gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-lg text-primary-600">
                        <i className={c.icon}></i>
                      </span>
                      <div>
                        <div className="text-xs text-foreground-500">{c.label}</div>
                        <div className="text-sm font-bold text-foreground-900">{c.value}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-6 border-t border-background-200 pt-4">
                  <Link
                    to="/"
                    className="flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-megaphone-fill"></i>
                    回首页开吃新瓜
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}